// extracted by mini-css-extract-plugin
export var widgets = "styles-module--widgets--721d4";